import find from 'lodash/find';

import { Observable } from '../../Utils/observable';

// See lang list: http://www.oujood.com/html-attribut/HTML_attribut-lang.php
interface ITranslation {
    key: string
    fr?: string
    en?: string
    de?: string
    it?: string
    e?: string // Thaï
}

const getWindowLangage = (): string => {
    let userlang = document.documentElement.lang;
    if (!userlang) userlang = window.navigator.userLanguage || window.navigator.language;
    // because we can have "en-US"
    let lang = 'en';
    if (userlang.includes('fr')) lang = 'fr';
    else if (userlang.includes('en')) lang = 'en';
    else if (userlang.includes('de')) lang = 'de';
    else if (userlang.includes('it')) lang = 'it';
    else if (userlang.includes('e')) lang = 'e';

    return lang;
};

export enum SimpleEvent {
    Change,
}

export class ConfigurationTranslation extends Observable<SimpleEvent, string> {
    private langage: string

    constructor() {
        super('Translation');
        this.langage = getWindowLangage();
    }

    public getTranslatedString(key: string): string {
        let { langage } = this;
        if (!langage) langage = this.defaultLangage;
        return this.getLangageString(langage, key);
    }

    public getLangageString(langage: string, key: string): string {
        const translation = find(this.translations, (t) => t.key === key);
        let text = '';
        if (translation) {
            text = translation[langage] || translation.en || key;
        } else {
            text = key;
        }
        return text;
    }

    private defaultLangage = 'en'

    public setDefaultLangage(defaultLangage: string): void {
        this.defaultLangage = defaultLangage;
    }

    public setLangage(lang: string): void {
        this.langage = lang;
        this.notifyChange(lang);
    }

    private translations: ITranslation[]

    public setTranslations(translations: ITranslation[]): void {
        this.translations = translations;
        this.notifyChange('');
    }
}
